import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { APIService } from "./APIService";

@Injectable({
  providedIn: "root",
})
export class WebServer {
  constructor(public http: HttpClient) {}

  // //live
  public BASE_URL = "https://api.vkonnecthealth.com:3000/";
  public Razor_URL = "https://api.vkonnecthealth.com:7070/"; 

  //dev
  // public BASE_URL = "https://apidev.vkonnecthealth.com:3000/"; //dev
  // public Razor_URL = "https://apidev.vkonnecthealth.com:7070/"; //dev

  //login
  public login = this.BASE_URL + "patientRoutes/checkPassword";

  //register
  public registerData = this.BASE_URL + "patientRoutes/add_patient";

  //getAllStates
  public getStates = this.BASE_URL + "api/all_States";

  //getAllCities
  public getcities = this.BASE_URL + "api/getCitiesByState";

  //getAllDoctors
  public getAllDoctors = this.BASE_URL + "api/doctor_list";

  //getTwilioToken
  // public getTwilioToken = "https://connect.vytal.in:3003/token"; //live
  public getTwilioToken = "https://api.vkonnecthealth.com:3003/token";  //dev
  // getUpcomingAppointments
  public getUpcomingAppointments = this.BASE_URL + "api/PatientUpcomingAppoint";

  // getPastAppointments
  public getPastAppointments = this.BASE_URL + "api/PatientPastAppoint";

  // createOrderID
  public createOrderID = this.BASE_URL + "create_orderid";

  // getSlots
  public getSlots = this.BASE_URL + "api/GetSlotsForPatient";

  // addpatient
  public addpatient = this.BASE_URL + "api/add_patient";

  // addAppointment
  public addAppointment = this.BASE_URL + "api/add_Appoinment";

  // get_razorAcc
  public get_razorAcc = this.Razor_URL + "get_razorAcc";

  // transferOnResp
  public transferOnResp = this.Razor_URL + "transferOnResp";

  // sendMessage
  public sendMessage = this.BASE_URL + "api/videoLinksms_send";

  // updatePatent
  public updatePatent = this.BASE_URL + "api/updatePatent";

  //forgotpassword
  public forgotpassword = this.BASE_URL + "api/patient_forgotpassword";

  //PatentNewOtp
  public PatentNewOtp = this.BASE_URL + "api/PatentNewOtp";

  //PatentNewOtpLogin
  public PatentNewOtpLogin = this.BASE_URL + "api/PatentNewOtpLogin";

  //otpregister
  public otpregister = this.BASE_URL + "api/generateOtpPatient";

  //updateFCM
  public updateFCM = this.BASE_URL + "api/updateFcmToken";

  //add_Appoinment
  public add_Appoinment = this.BASE_URL + "api/add_Appoinment";

  // checkUpdate
  public checkUpdate = this.BASE_URL + "api/AndroidIosCheck";

  // getPatientAppointments
  public getPatientAppointments = this.BASE_URL + "api/getPatientAppointments";

  // bookAppointment
  public bookAppointment = this.BASE_URL + "api/bookAppointment";

  // cancelAppointment
  public cancelAppointment = this.BASE_URL + "api/cancelAppointment";

  // resheduleAppointment
  public resheduleAppointment = this.BASE_URL + "api/resheduleAppointment";

  // updatefcmToken
  public updatefcmToken = this.BASE_URL + "api/updatePatientFcmToken";

  // callReject
  public callReject = this.BASE_URL + "super/callReject";

   //getspecific doctor
   public getspecificDoctor = this.BASE_URL + "api/getdoc_byid";
}
